import { useEffect, useState } from "react";
import { X } from "@phosphor-icons/react";
import api from "../../lib/api";

export default function StatsPanel({ automationId, automationName, onClose }) {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get(`/automations/${automationId}/stats`).then((r) => setStats(r.data)).catch(() => {});
  }, [automationId]);

  const items = stats ? [
    ["Clienti entrati", stats.entrati, "stats-entrati"],
    ["Clienti usciti", stats.usciti, "stats-usciti"],
    ["Messaggi inviati", stats.messaggi_inviati, "stats-messaggi"],
    ["Aperture", stats.aperture, "stats-aperture"],
    ["Click", stats.click, "stats-click"],
    ["Risposte", stats.risposte, "stats-risposte"],
    ["Coupon assegnati", stats.coupon_assegnati, "stats-coupon-assegnati"],
    ["Coupon usati", stats.coupon_usati, "stats-coupon-usati"],
    ["Prenotazioni generate", stats.prenotazioni_generate, "stats-prenotazioni"],
    ["Fatturato stimato", `€${stats.fatturato_stimato}`, "stats-fatturato"],
  ] : [];

  return (
    <div className="fixed inset-0 z-[60] bg-black/40 flex items-end sm:items-center justify-center" onClick={onClose}>
      <div className="bg-white w-full sm:max-w-lg rounded-t-xl sm:rounded-lg" onClick={(e) => e.stopPropagation()} data-testid="stats-panel">
        <div className="flex items-center justify-between px-5 py-4 border-b border-zinc-200">
          <div className="min-w-0">
            <h3 className="font-display font-bold text-lg">Statistiche</h3>
            <p className="text-xs text-zinc-500 truncate">{automationName}</p>
          </div>
          <button onClick={onClose} className="p-2 text-zinc-500" data-testid="stats-close"><X size={18} /></button>
        </div>
        <div className="p-5 grid grid-cols-2 gap-3">
          {items.map(([label, value, testid]) => (
            <div key={label} className="bg-zinc-50 border border-zinc-200 rounded-lg p-3" data-testid={testid}>
              <div className="text-[10px] uppercase tracking-wider font-semibold text-zinc-500">{label}</div>
              <div className="font-display text-2xl font-black text-zinc-900">{value}</div>
            </div>
          ))}
        </div>
        <p className="px-5 pb-5 text-[11px] text-zinc-400">Aperture, click e risposte saranno tracciati con l'integrazione dei provider (WhatsApp API, email, SMS). Il fatturato stimato usa il ticket medio dalle impostazioni.</p>
      </div>
    </div>
  );
}
